class ZoomDiapo {

  /* ========================================================================
   * Puzzle.js
   * ======================================================================== */
  constructor( el ) {
    this.inited = false;
    this.el = el;
    this.opened = false;
    this.options = Object.assign({
      src: null,
      name:'',
      copyright:'',
      adheaderbidding: false,
    }, el.dataset );
  }

  async openZoomDiapo() {
    let zoom = this;
    if (zoom.opened) return;
    let overlay = document.createElement('div');
    overlay.classList.add( 'zoom-overlay' );


      overlay.innerHTML =
        '<div class="zoom-header">'+
          '<span  class="img-title">'+zoom.options.name+'</span>'+
          '<span class="zoom-close">FERMER&nbsp;</span>'+
        '</div>' +
        '<div class="zoom-container  '+zoom.options.display+'">'+
            '<img src="'+zoom.options.src+'" class="img-fluid" alt="'+zoom.options.name+'"/>'+
            '<span class="copyright">'+zoom.options.copyright+'</span>'+
        '</div>' ;

    document.body.appendChild( overlay );

    document.documentElement.classList.add('zoom_image');
    overlay.querySelector( '.zoom-close' ).addEventListener( 'click', (e) => {
      e.preventDefault();
      zoom.closeZoomLayer();
    });

    zoom.opened = true;
    return;
  }

  async closeZoomLayer() {
    let zoom = this;
    document.querySelector( '.zoom-overlay' ).remove();
    document.documentElement.classList.remove('noscroll');
    document.documentElement.classList.remove('zoom_image');
    zoom.opened = false;
  }



  async init(){
    let zoom = this;
    zoom.el.addEventListener( 'click', (e) => {
      e.preventDefault();
      zoom.openZoomDiapo();
    });

    // remove loading

  }
}


let gptadslots = gptadslots || [];
DOMReady( function(){
  [... document.querySelectorAll('.zoom_out')].map( l => {
    let zoom = new ZoomDiapo(l);
    zoom.init();
  });
});
